
export const data={
    mues_tech_logo:"https://mues-solution.s3.ap-south-1.amazonaws.com/svg/mues-tech.svg",
    play_store_url:"https://play.google.com/store/apps/developer?id=Creaxt+Inc",
    ios_store_url:"https://apps.apple.com/hr/developer/creaxt-inc/id1500222071",
    description:"mues believes in creating products and provides services which are designed to be as limitless as a child’s imagination to conquer the 21st Century World.",
    contact:{
        title:"Reach out to us",
        description:"Get your questions answered about mues solution.",
        call:"+91 7888033249",
    },
    company:{
        title:"Company",
        list:[
            {
                id:1,
                name:"About Us",
                path:"/about"
            },
            {
                id:2,
                name:"Philosophy",
                path:"/philosophy"
            },
            {
                id:3,
                name:"Careers",
                path:"/career"
            },
            {
                id:4,
                name:"Blogs",
                path:"/blog"
            },
            {
                id:5,
                name:"Privacy Policy",
                path:"/privacy-policy"
            },
            {
                id:6,
                name:"Terms and Conditions",
                path:"/terms-and-condition"
            },
        ]
    },
    help_and_support:{
        title:"Help & Support",
        list:[
            {
                id:1,
                name:"User Guidelines",
                path:"/help-center/user-guidelines"
            },
            {
                id:2,
                name:"Site Map",
                path:"/help-center/site-map"
            },
            {
                id:3,
                name:"Refund Policy",
                path:"/help-center/refund-policy"
            },
            {
                id:4,
                name:"Takedown Policy",
                path:"/help-center/takedown-policy"
            },
            {
                id:5,
                name:"Grievance Redressal",
                path:"/help-center/grievance-redressal"

            },
            {
                id:6,
                name:"mues PRO",
                path:"/help-center/mues-pro",

            },
        ]
    },
    resources:{
        title:"Resources",
        list:[
            {
                id:1,
                name:"mues Framework",
                path:"/resources/mues-framework"
            },
            {
                id:2,
                name:"Preschool Guide",
                path:"/resources/preschool-guide"
            },
            {
                id:3,
                name:"Preschool Setup",
                path:"/resources/preschool-setup"
            },
            {
                id:4,
                name:"Digital Marketing",
                path:"/resources/digital-marketing"
            },
            {
                id:5,
                name:"Worksheets",
                path:"/resources/worksheets"
            },
            {
                id:6,
                name:"NEP 2020",
                path:"/resources/nep-2020"
            }
        ]
    },
    mues_network:{
        title:"mues.network",
        list:[
            {
                id:1,
                name:"Register your Preschool",
                path:"/mues-network/register-preschool"
            },
            {
                id:2,
                name:"Near By Preschool",
                path:"/mues-network/preschool_near_me"
            },
            {
                id:3,
                name:"Parent Guide",
                path:"/mues-network/parent-guide"
            },
            {
                id:4,
                name:"Consultant Guide",
                path:"/mues-network/consultant-guide"
            }
        ]
    },
    mues_product:{
        title:"Products",
        mues_product_list:[
            {
                id:1,
                logo:"https://mues-principal.s3.ap-south-1.amazonaws.com/muse-teacher-logo.png",
                name:"mues Teacher",
                play_store_url:"https://play.google.com/store/apps/details?id=com.creaxt.muesteacher",
            },
            {
                id:2,
                logo:"https://mues-principal.s3.ap-south-1.amazonaws.com/product-mues-academy-logo.png",
                name:"mues academy",
                play_store_url:"https://play.google.com/store/apps/details?id=com.creaxt.muesacademy",
            },
            {
                id:3,
                logo:"https://mues-principal.s3.ap-south-1.amazonaws.com/muse-parent-logo.png",
                name:"mues Parent",
                play_store_url:"https://play.google.com/store/apps/details?id=com.creaxt.muesparent",
            },
            {
                id:5,
                logo:"https://mues-principal.s3.ap-south-1.amazonaws.com/product-mues-play-ar-logo.png",
                name:"mues PlayAr",
                play_store_url:"https://play.google.com/store/apps/details?id=com.creaxt.museplay.AR",
            },
        ]
    },
    copyright:"Creaxt Innovations Private Limited"
}